import SectorService from '../services/Sector.js';
import BenefitService from '../services/Benefit.js';
import DevelopmentStageService from '../services/DevelopmentStage.js';
import GeographicalAreaService from '../services/GeographicalArea.js';
import CountryService from '../services/Country.js';
import PatentStatusService from '../services/PatentStatus.js';
import CompanyTypeService from '../services/CompanyTypes.js';
import InvestmentTypeService from '../services/InvestmentTypes.js';
import CurrencyService from '../services/Currencies.js';
import LibraryGroupService from '../services/LibraryGroup.js';
import InfiniteLoading from 'vue-infinite-loading';
import Helper from '../Helper.js';
import EditorJquery from '../innovation/editor/EditorJquery.js';
import Multiselect from 'vue-multiselect';

if($('#dashboard--innovation-library-single').length){
    var app = new Vue({
        el: '#dashboard--innovation-library-single',
        data: {
            group: {},
            innovations: [],
            sectors:[],
            countries:[],
            developmentStages:[],
            benefits:[],
            patentStatuses:[],
            geographicalAreas:[],
            companyTypes:[],
            investmentTypes:[],
            currencies:[],
            slug: slug,
            loading: false,
            showGroup: false,
            filter: null,
            Helper: Helper,
            LibraryGroupService: LibraryGroupService,
            page: 1
        },
        methods: {
            get(){
                if (!this.loading) {
                    this.loading = true;
                    var page = JSON.parse(JSON.stringify(this.page));

                    this.page++;
                    axios.get('/api/v1/library-group/' + this.slug + '?page=' + page + '&filter=' + this.filter).then((response) => {


                        if (page == 1) {
                            this.group = response.data;
                        }

                        if (page == 1) {
                            this.innovations = response.data.innovations.data;
                        } else {
                            this.innovations.push.apply(this.innovations, response.data.innovations.data)
                        }

                        this.loading = false;

                        if (page == response.data.innovations.last_page) {
                            this.$refs.InfiniteLoading.stateChanger.complete();
                        } else {
                            this.$refs.InfiniteLoading.stateChanger.loaded();
                        }
                    }).catch(error => {
                        this.errorHandler(error);
                        this.loading = false;
                    });
                }
            },
            onFilterChange(){
                this.page = 1;
                if(this.$refs.InfiniteLoading){
                    this.$refs.InfiniteLoading.stateChanger.reset(); 
                }
                this.get();
            },
            edit(){
                EditorJquery.jqueryHelpers();
                this.group = JSON.parse(JSON.stringify(this.group));
                this.showGroup = true;
            },
            save(){
                this.loading = true;

                if(!this.group.name){
                    this.$toasted.error('The group must have a name');
                    return;
                }

                this.group.country_ids_only = this.group.countries;
                if (this.group.countries && this.group.countries.length > 0) {
                    this.group.country_ids_only = this.group.countries.map(function (a) {
                        if (a.id !== undefined) {
                            return a.id;
                        }
                    });
                }

                this.group.sector_ids_only = this.group.sectors;
                if (this.group.sectors && this.group.sectors.length > 0) {
                    this.group.sector_ids_only = this.group.sectors.map(function (a) {
                        if (a.id !== undefined) {
                            return a.id;
                        }
                    });
                }

                this.group.benefit_ids_only = this.group.benefits;
                if (this.group.benefits && this.group.benefits.length > 0) {
                    this.group.benefit_ids_only = this.group.benefits.map(function (a) {
                        if (a.id !== undefined) {
                            return a.id;
                        }
                    });
                }

                this.group.development_ids_only = this.group.development_stages;
                if (this.group.development_stages && this.group.development_stages.length > 0) {
                    this.group.development_ids_only = this.group.development_stages.map(function (a) {
                        if (a.id !== undefined) {
                            return a.id;
                        }
                    });
                }

                this.group.patent_ids_only = this.group.patent_statuses;
                if (this.group.patent_statuses && this.group.patent_statuses.length > 0) {
                    this.group.patent_ids_only = this.group.patent_statuses.map(function (a) {
                        if (a.id !== undefined) {
                            return a.id;
                        }
                    });
                }

                this.group.investment_ids_only = this.group.investment_types;
                if (this.group.investment_types && this.group.investment_types.length > 0) {
                    this.group.investment_ids_only = this.group.investment_types.map(function (a) {
                        if (a.id !== undefined) {
                            return a.id;
                        }
                    });
                }

                this.group.company_ids_only = this.group.company_types;
                if (this.group.company_types && this.group.company_types.length > 0) {
                    this.group.company_ids_only = this.group.company_types.map(function (a) {
                        if (a.id !== undefined) {
                            return a.id;
                        }
                    });
                }

                // if ($('.s-tag-data').val() !== undefined && $('.s-tag-data').val() !== '') {
                //     this.group.search_keywords = [];
                //     let searchTagsData = JSON.parse($('.s-tag-data').val());
                //     searchTagsData.forEach(element => this.group.search_keywords.push(element.tag))
                // } else if (this.group.search_keywords && this.group.search_keywords.length > 0) {
                //     this.group.search_keywords = this.group.search_keywords.map(keyword => keyword.word);
                // }

                var _tags = [];
                $('.s-chips-initial').children('.chip').each(function(i) { 
                    var text = $(this).clone().children().remove().end().text()
                    _tags.push(text); // because theres a child element beside the text we want
                });
                this.group.search_keywords = _tags;

                if ((this.group.sector_ids_only === undefined || this.group.sector_ids_only.length === 0) &&
                    (this.group.country_ids_only === undefined || this.group.country_ids_only.length === 0) &&
                    (this.group.benefit_ids_only === undefined || this.group.benefit_ids_only.length === 0) &&
                    (this.group.development_ids_only === undefined || this.group.development_ids_only.length === 0) &&
                    (this.group.patent_ids_only === undefined || this.group.patent_ids_only.length === 0) &&
                    (this.group.investment_ids_only === undefined || this.group.investment_ids_only.length === 0) &&
                    (this.group.company_ids_only === undefined || this.group.company_ids_only.length === 0) &&
                    this.group.search_keywords.length === 0) {
                    this.$toasted.error('The group must have a category or keyword');
                    return;
                }

                // if ($('.tag-data').val() !== undefined && $('.tag-data').val() !== '') {
                //     this.group.keywords = [];
                //     let tagsData = JSON.parse($('.tag-data').val());
                //     tagsData.forEach(element => this.group.keywords.push(element.tag))
                // } else if (this.group.keywords && this.group.keywords.length > 0) {
                //     this.group.keywords = this.group.keywords.map(keyword => keyword.word);
                // }

                var _tags2 = [];
                $('.chips-initial').children('.chip').each(function(i) { 
                    var text = $(this).clone().children().remove().end().text()
                    _tags2.push(text); // because theres a child element beside the text we want
                });
                this.group.keywords = _tags2;

                axios.patch('/api/v1/library-group/'+this.group.slug, this.group).then(() =>  {
                    location.reload();
                    this.showGroup = false;
                    this.$toasted.success('Group Saved');
                }).catch(error => {
                    this.errorHandler(error);
                    this.loading = false;
                });
            },
            favorite(e, innovation, slug, Helper){
                e.stopPropagation();
                axios.get('/api/v1/library-group/'+slug+'/favorite/'+innovation.id).then(() =>  {
                    if(this.filter == 'favorites' && innovation.isFavorite){
                        this.page = 1;
                        this.get();
                    }else{
                        innovation.isFavorite = innovation.isFavorite ? false : true;
                    }
                }).catch(error => {
                    this.errorHandler(error);
                });
            },
            errorHandler(error){
                console.log(error);
                if(error.response && typeof error.response.data === 'string'){
                    this.$toasted.error(error.response.data);
                }else if(error.response){
                    this.$toasted.error(error.response.data.message);
                }
            },
            setCountries(countries) {
                let name = '';
                countries.forEach((country) => {
                    if (name) {
                        name += ', '
                    }
                    name += country.name
                });
                return name
            },
            setKeywords(keywords) {
                let keys = '';
                keywords.forEach((keyword) => {
                    if (keys) {
                        keys += ', '
                    }
                    keys += keyword.word
                });
                return keys
            },
            setData(data) {
                let name = '';
                data.forEach((datum) => {
                    if (name) {
                        name += ', '
                    }
                    name += datum.name
                });
                return name
            }
        },
        mounted(){
            SectorService.getSectors().then(data => {
                this.sectors = data;
            });
            BenefitService.getBenefits().then(data => {
                this.benefits = data;
            });
            CountryService.getCountries('libraries').then(data => {
                this.countries = data;
            });
            DevelopmentStageService.getDevelopmentStages().then(data => {
                this.developmentStages = data;
            });
            PatentStatusService.getPatentStatuses().then(data => {
                this.patentStatuses = data;
            });
            GeographicalAreaService.getGeographicalAreas().then(data => {
                this.geographicalAreas = data;
            });
            CompanyTypeService.getCompanyTypes().then(data => {
                this.companyTypes = data;
            });
            InvestmentTypeService.getInvestmentTypes().then(data => {
                this.investmentTypes = data;
            });
            CurrencyService.getCurrencies().then(data => {
                this.currencies = data;
            });
        },
        components: {
            InfiniteLoading,
            'multiselect': Multiselect
        },
    });
}